export default __webpack_public_path__ + "23e300478b836db226890e6cd88bc542.png";